export const useDownload = () => {
  function downloadFile(filename, content, mimeType) {
    // credit: https://www.bitdegree.org/learn/javascript-download
    let text = content;
    let element = document.createElement('a');
    element.setAttribute('href', `data:${mimeType};charset=utf-8,` + encodeURIComponent(text));
    element.setAttribute('download', filename);
    //element.setAttribute('target', '_blank');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  function downloadBinaryFile(filename, buffer, mimeType = 'application/gzip') {
    // Create a Blob from the buffer
    const blob = new Blob([buffer], { type: mimeType });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Create download link
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', filename);
    element.style.display = 'none';

    // Append to body, click, and clean up
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

    // Release the blob URL to free memory
    URL.revokeObjectURL(url);
  }

  return {
    downloadFile,
    downloadBinaryFile,
  };
};
